<template>
  <div class="case">
    <!-- 切换模式 -->
    <banner
      img="../assets/img/bgtop.jpg"
      :title="currentCaseList[swiperActiveIndex].title"
    />
    <div class="case-product">
      <div class="content-left">
        <el-menu
          :default-active="swiperActiveIndex"
          class="el-menu-vertical-demo"
          @select="handleSelect"
          :collapse="false"
        >
          <el-menu-item
            v-for="menu in currentCaseList"
            :index="menu.menuKey"
            :key="menu.menuKey"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">{{ menu.title }}</span>
          </el-menu-item>

          <!-- <el-menu-item index="1">
            <i class="el-icon-menu"></i>
            <span slot="title">总汇</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-menu"></i>
            <span slot="title">MES系统</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-menu"></i>
            <span slot="title">WMS系统</span>
          </el-menu-item> -->
        </el-menu>
      </div>
      <div class="content-right">
        <div class="case-content" style="">
          <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
            <swiper-slide
              class="swiper-slide slide-one"
              v-for="(item, index) in currentCaseList"
              :key="index"
            >
              <img :src="item.imgLists" alt="" />
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <div v-html="currentCaseList[swiperActiveIndex].html"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      swiperActiveIndex: 0,
      // caseImgList: [
      //   require("@/assets/img/case/c-case.png"),
      //   require("@/assets/img/case/MES.jpg"),
      //   require("@/assets/img/case/WNS.jpg"),
      //   require("@/assets/img/case/WCS.jpg"),
      //   require("@/assets/img/case/chaiduo.jpg"),
      // ],
      // menus: [{ label: "总汇", icon: "", indexKey: "0" }],
      currentCaseList: [],
      desLists: [
        {
          keyPage: "package",
          // imgLists: require("@/assets/img/case/test.jpg"),
          imgLists: require("@/assets/img/case/c-case2.png"),
          title: "智能包装数字化软件平台",
          html: `
            <div v-else class="p-title">
              <div class="title-head">MES系统</div>
              <div class="title-text">※ MES（制造执行系统）是整个系统中生产数据的主要来源。监控生产计划的执行、生产的用料、生产的进度、生产的效率。</div>
              <div class="title-head">WMS系统</div>
              <div class="title-text">※ WMS（仓储管理系统）用于管理原料的进出库，成品的进出库、库存的数量、库存的盘点。</div>
              <div class="title-head">WCS系统</div>
              <div class="title-text">※ WCS（仓储控制系统）用于控制自动化包装设备、AGV、机器人，对仓库中实物进行进出、入库的操作。</div>
              <div class="title-head">赋码追溯系统</div>
              <div class="title-text">※ 通过唯一标识码（如二维码、RFID、条形码）对产品进行全生命周期管理的技术体系，实现从生产、流通到消费的全程数字化追踪与防伪。</div>
              <div class="title-head">机器人傻瓜操作系统</div>
              <div class="title-text">※ 一个面向非专业用户的零代码/低代码机器人操作系统，无需编程基础，通过可视化拖拽和自然语言指令即可快速部署机器人任务。像玩积木一样控制机器人，用流程图模块拼装机器人行为（如“移动→抓取→放置”），一键选择生产。</div>
              </div>
              `,
          // <div class="title-text">※ 管理整个系统的共享数据，提供对外的查询接口和数据导入接口，也是所有移动设备的数据服务器。</div>
          // <div class="title-text">※ 在线内、外包装数据采集，对接生产设备，自动获取设备运行参数和生产的数据实时监控生产运行状态。</div>
          // <div class="title-text">※ 自动选择垛型进行码垛，自动设别垛型，进行拆垛安全防护，自动呼叫搬运。</div>
        },
        {
          keyPage: "package",
          imgLists: require("@/assets/img/case/MES2.png"),
          title: "MES系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">MES系统</div>
              <div class="title-text">※ MES（制造执行系统）是整个系统中生产数据的主要来源。监控生产计划的执行、生产的用料、生产的进度、生产的效率。</div>
            </div>
          `,
        },
        {
          keyPage: "package",
          imgLists: require("@/assets/img/case/WMS2.png"),
          title: "WMS系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">WMS系统</div>
              <div class="title-text">※ WMS（仓储管理系统）用于管理原料的进出库，成品的进出库、库存的数量、库存的盘点。</div>
            </div>
          `,
        },
        {
          keyPage: "package",
          imgLists: require("@/assets/img/case/WCS2.png"),
          title: "WCS系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">WCS系统</div>
              <div class="title-text">※ WCS（仓储控制系统）用于控制自动化包装设备、AGV、机器人，对仓库中实物进行进出、入库的操作。</div>
            </div>
          `,
        },
        {
          keyPage: "package",
          imgLists: require("@/assets/img/case/fumazhuiyuan2.png"),
          // imgLists: require("@/assets/img/case/fuma.jpg"),
          title: "赋码追溯系统",
          // title: "机器人码垛、拆垛、视觉控制系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">赋码追溯系统</div>
              <div class="title-text">※ 通过唯一标识码（如二维码、RFID、条形码）对产品进行全生命周期管理的技术体系，实现从生产、流通到消费的全程数字化追踪与防伪。</div>
              <div class="title-text">1、为每个产品赋予独立ID（如“瓶装水序列号”），避免批次混肴 。</div>
              <div class="title-text">2、记录原料采购、生产加工、仓储物流、销售终端等各环节数据。</div>
              <div class="title-text">3、消费者扫码即可验证产品真伪，企业可监控窜货行为 。</div>
              <div class="title-text">4、出现质量问题时可快速定位问题环节（如某批次原料不合格） 。</div>
            </div>
          `,
        },
        {
          keyPage: "package",
          imgLists: require("@/assets/img/case/robot3.jpg"),
          title: "机器人傻瓜操作系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">机器人傻瓜操作系统</div>
              <div class="title-text">※ 一个面向非专业用户的零代码/低代码机器人操作系统，无需编程基础，通过可视化拖拽和自然语言指令即可快速部署机器人任务。</div>
              <div class="title-text">※ 极简交互：像玩积木一样控制机器人，用流程图模块拼装机器人行为（如“移动→抓取→放置”），一键选择生产。</div>
            </div>
          `,
        },
        // {
        //   keyPage: "package",
        //   imgLists: require("@/assets/img/case/chaiduo.jpg"),
        //   title: "机器人、视觉控制系统",
        //   // title: "机器人码垛、拆垛、视觉控制系统",
        //   html: `
        //     <div v-else class="p-title">
        //       <div class="title-head">机器人码垛、拆垛、视觉控制系统</div>
        //       <div class="title-text">※ 自动选择垛型进行码垛，自动设别垛型，进行拆垛安全防护，自动呼叫搬运。</div>
        //     </div>
        //   `,
        // },
        // { 
        //   keyPage: "package",
        //   imgLists: require("@/assets/img/case/test.jpg"),
        //   // imgLists: require("@/assets/img/case/shujucaiji.jpg"),
        //   title: "数据采集、设备监控系统",
        //   // title: "机器人码垛、拆垛、视觉控制系统",
        //   html: `
        //     <div v-else class="p-title">
        //       <div class="title-head">数据采集、设备监控系统</div>
        //       <div class="title-text">※ 通过实时生产线状态监测，我们能够全面了解设备状态和订单进度，及时发现并解决潜在的生产瓶颈。借助设备OEE（综合设备效率）数据，我们可以量化设备的实际运转效率，从而识别优化空间。结合生产汇总报告，管理层可以全面掌握生产状况，确保生产任务按时完成，资源得到充分利用。此系统帮助提高生产线的运行效率、降低停机时间，并且及时调整生产策略，优化整体生产流程。</div>
        //     </div>
        //   `,
        // },
      ],

      swiperOption: {
        autoplay: false, // 自动切换
        loop: false, // 无限循环
        initialSlide: 0,
        // speed: 500,
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // width:100,
        // height:500,
        // autoWidth:true,
        // notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        // slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        // height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        pagination: {
          el: ".swiper-pagination",
          // type: 'fraction',
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.$nextTick(() => {
              this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex;
              console.log(
                this.$refs.mySwiper.swiper.activeIndex,
                "this.$refs.mySwiper.swiper.activeIndex"
              );

              // this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex;
            });
          },
        },
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleSelect(index) {
      this.$refs.mySwiper.swiper.slideTo(Number(index), 500, false);
      this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex;
      console.log(index, "handleSelect");
    },
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        console.log(newQuery, "newRoute123213");
        if (!newQuery.id) return;
        this.currentCaseList = this.desLists
          .filter((item) => item.keyPage == newQuery.type)
          .map((el, index) => {
            el.menuKey = String(index);
            return el;
          });
        console.log(this.currentCaseList, "newRoute123213");
        this.$nextTick(() => {
          this.swiperActiveIndex = String(Number(newQuery.id) - 1);
          // this.swiperActiveIndex = Number(newQuery.id);
          this.$refs.mySwiper.swiper.slideTo(this.swiperActiveIndex, 500, false);
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.p-title {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  .title-font {
    font-size: 28px;
    font-weight: 400;
    color: #333;
    line-height: 1.6;
  }
  .title-head {
    font-size: 26px;
    font-weight: 400;
    color: #e13834;
    line-height: 2;
    // line-height: 52px;
  }
  .title-text {
    font-size: 22px;
    color: #14679f;
    line-height: 1.4;
    &::before {
      content: "";
      width: 10px;
      display: inline-block;
    }
    .title-img img {
      word-wrap: break-word;
      // float: right;
      width: 120px;
      height: 120px;
    }
  }
}
</style>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;
  .case-product {
    width: 1240px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #ffffff;
    @include row-c;
    justify-content: space-between;
    align-items: flex-start;
    .content-left {
      width: 260px;
      height: 100%;
      // border: 1px solid red;
      padding: 20px;
      box-sizing: border-box;
    }
    .content-right {
      width: 1000px;//964
      padding: 20px 20px;
      box-sizing: border-box;
      // border: 1px solid red;
      .case-content {
        width: 100%;
        .case-title {
          font-size: 32px;
          font-family: "阿里楷体";
          margin-bottom: 10px;
          color: #e13834;
        }
        .swiper-slide {
          // height: 400px;
          // background: #e13834;
          img {
            width: 100%;
            height: 350px;//450
            object-fit: fill;
          }
        }
      }
    }
  }
}
</style>
